import React, { useState, useContext, useEffect } from 'react';
import axiosConfig from '../../../../../utils/axiosConfig';
import { Avatar, Box, CardHeader, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';
import CommentModalForm from './CommentModalForm/CommentModalForm';
import { StateContext, DispatchContext } from '../../../../../context/Provider';

const CommentItem = (props) => {

    const { comment, classes } = props;

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [anchorEl, setAnchorEl] = useState(null);
    const openDropdown = Boolean(anchorEl);
    const [commentModalOpen, setCommentModalOpen] = useState(false);

    const handleMenu = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCommentModalOpen = () => {
        setCommentModalOpen(true);
    }

    const handleCommentModalClose = () => {
        setCommentModalOpen(false);
    }

    async function removeComment(commentID) {

        globalDispatch({type: 'setIsLoading', value: true});

        try {
            const response = await axiosConfig.post(`/comments/${commentID}`, {
                _method: "DELETE"
            }); 

            const { status_code, message } = response.data;

            if (status_code == 'ok') {
                props.fetchAnnouncements();
            }

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    return (
        <Box key={comment.id}>
            <CardHeader
                className={classes.cardHeader}
                avatar={
                    <Avatar aria-label="recipe" className={classes.medium} src={comment.avatar}>D</Avatar>
                }
                action={
                    authState.user.id === comment.posted_by && (
                        <IconButton 
                            aria-label="settings"
                            onTouchStart={(event) => event.stopPropagation()}
                            onMouseDown={(event) => event.stopPropagation()} 
                            onClick={handleMenu}
                        >
                            <MoreVertIcon className={classes.moreVertIcon} />
                        </IconButton>
                    )
                }
                title={
                    <Typography className={classes.cartTitle} gutterBottom variant="body1" component="h2">
                        { comment.author }
                    </Typography>
                }
                subheader={
                    <Typography className={classes.subHeader} variant="body2" color="textSecondary" component="p">
                        {`${comment.formatted_updated_at} ${comment.is_edited ? "(edited)" : ''}`}
                    </Typography>
                }
            />

            <Menu
                id="menu-cardheader"
                anchorEl={anchorEl}
                getContentAnchorEl={null} // this will display the popover below the icon
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                keepMounted
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                open={openDropdown}
                onClose={handleClose}
            >
                <MenuItem onClick={() => { handleClose(); handleCommentModalOpen(); }}>Edit Comment</MenuItem>
                <MenuItem onClick={() => { 
                    if (window.confirm(`Are you sure you want to remove this comment?`)) {
                        handleClose();
                        removeComment(comment.id);
                    }
                }}>Delete</MenuItem>
            </Menu>

            <Box px={2}>
                <Typography className={classes.subHeader} variant="body2" color="textSecondary" component="p">
                    { comment.description }
                </Typography>
            </Box>

            { commentModalOpen ? (
                <CommentModalForm
                    open={commentModalOpen}
                    handleClose={handleCommentModalClose}
                    dialogTitle={`Edit Comment`}
                    commentID={comment.id}
                    description={comment.description}
                    fetchAnnouncements={props.fetchAnnouncements}
                />
                ) : null
            }
        </Box>
    );
}

export default CommentItem;